export const EMPTY_PROMISE_FUNCTION = () => new Promise<any>((resolve) => resolve(undefined));
export const EMPTY_FUNCTION = () => undefined;
